import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/falken/banner-splash-bg.webp'


const _withScopeId = n => (_pushScopeId("data-v-1c24dfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fl_home_slider p-0" }
const _hoisted_2 = {
  id: "carouselExampleIndicators",
  class: "carousel slide banner_slider_wrapper",
  "data-bs-ride": "carousel"
}
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = {
  key: 0,
  class: "carousel-item active"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-1c24dfae><div class=\"container wrapper\" data-v-1c24dfae><div class=\"text opacity-1\" data-v-1c24dfae><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-1c24dfae> Discover the ultimate driving experience. </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"Falken Banner Image\" data-v-1c24dfae><iframe src=\"https://www.youtube.com/embed/pkWjSyjRDrE?controls=0&amp;autoplay=1&amp;mute=1&amp;playsinline=1&amp;loop=1&amp;playlist=pkWjSyjRDrE&amp;rel=0\" data-v-1c24dfae></iframe></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "carousel-item active"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-1c24dfae><div class=\"container wrapper\" data-v-1c24dfae><div class=\"text opacity-1\" data-v-1c24dfae><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-1c24dfae> THE FALKEN TYRE RANGES </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"Falken Banner Image\" data-v-1c24dfae><iframe src=\"https://www.youtube.com/embed/5kyIpohwqQI?controls=0&amp;autoplay=1&amp;mute=1&amp;playsinline=1&amp;loop=1&amp;playlist=5kyIpohwqQI&amp;rel=0\" data-v-1c24dfae></iframe></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tyreRangeRoute == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      ])
    ])
  ]))
}